"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleProxyCreativeQuerySchema = exports.AppleProxyCreativeIdParamsSchema = exports.AppleProxyCreativeListResponseSchema = exports.AppleProxyCreativeResponseSchema = exports.AppleProxyCustomProductPageCreativeSchema = exports.AppleProxyCreativeSetCreativeSchema = exports.AppleProxyCreativeSetAssetListSchema = exports.AppleProxyCreativeSetAssetSchema = exports.AppleProxyAssetSchema = exports.AppleProxyCreativeSchema = exports.AppleProxyCreativeLocalization = exports.AppleProxyCreativeStateReasonSchema = exports.AppleProxyCreativeTypeSchema = exports.AppleProxyCreativeStateSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const core_2 = require("./core");
const custom_product_pages_1 = require("./custom-product-pages");
exports.AppleProxyCreativeStateSchema = (0, core_1.StringUnion)(["VALID", "INVALID"]);
exports.AppleProxyCreativeTypeSchema = (0, core_1.StringUnion)([
    "CREATIVE_SET",
    "CUSTOM_PRODUCT_PAGE",
    // You get this... but its not listed in API doc
    "DEFAULT_PRODUCT_PAGE",
]);
exports.AppleProxyCreativeStateReasonSchema = (0, core_1.StringUnion)([
    "ASSET_DELETED",
    "CREATIVE_SET_UNSUPPORTED",
    "PRODUCT_PAGE_DELETED",
    "PRODUCT_PAGE_HIDDEN",
]);
exports.AppleProxyCreativeLocalization = typebox_1.Type.Object({
    appName: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    deviceClasses: (0, core_1.OptionalNullable)(core_2.AppleProxyDeviceClassSchema),
    language: (0, core_1.OptionalNullable)(core_2.LanguageSchema),
    languageCode: (0, core_1.OptionalNullable)(core_2.LanguageCodeSchema),
    promotionalText: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    shortDescription: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    subTitle: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
});
const AppleProxyCreativeProperties = {
    adamId: (0, core_1.OptionalNullable)(core_2.AppleProxyAdamRefSchema),
    creationTime: (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema),
    id: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    modificationTime: (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema),
    name: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    orgId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyOrgRefSchema),
    state: (0, core_1.OptionalNullable)(exports.AppleProxyCreativeStateSchema),
    stateReasons: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.AppleProxyCreativeStateReasonSchema)),
    type: (0, core_1.OptionalNullable)(exports.AppleProxyCreativeTypeSchema),
};
exports.AppleProxyCreativeSchema = typebox_1.Type.Object(AppleProxyCreativeProperties);
exports.AppleProxyAssetSchema = typebox_1.Type.Object({
    appPreviewDevice: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    deleted: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    orientation: (0, core_1.OptionalNullable)(custom_product_pages_1.AppleProxyOrientationSchema),
    type: (0, core_1.OptionalNullable)(custom_product_pages_1.AppleProxyAssetTypeSchema),
});
exports.AppleProxyCreativeSetAssetSchema = typebox_1.Type.Object({
    id: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    asset: (0, core_1.OptionalNullable)(exports.AppleProxyAssetSchema),
});
exports.AppleProxyCreativeSetAssetListSchema = typebox_1.Type.Array(exports.AppleProxyCreativeSetAssetSchema);
exports.AppleProxyCreativeSetCreativeSchema = typebox_1.Type.Object({
    creativeSetAssets: (0, core_1.OptionalNullable)(exports.AppleProxyCreativeSetAssetListSchema),
    languageCode: (0, core_1.OptionalNullable)(core_2.LanguageCodeSchema),
    ...AppleProxyCreativeProperties,
});
/**
 * API types for creative endpoints
 */
exports.AppleProxyCustomProductPageCreativeSchema = typebox_1.Type.Object({
    productPageId: custom_product_pages_1.AppleProxyCustomProductPageRefSchema,
    ...AppleProxyCreativeProperties,
});
const AppleProxyCreativesSchema = typebox_1.Type.Intersect([
    exports.AppleProxyCustomProductPageCreativeSchema,
    exports.AppleProxyCreativeSetCreativeSchema,
]);
exports.AppleProxyCreativeResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(AppleProxyCreativesSchema),
});
exports.AppleProxyCreativeListResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(typebox_1.Type.Array(AppleProxyCreativesSchema)),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyCreativeIdParamsSchema = (0, core_1.StrictObject)({
    creativeId: ruby_1.AppleProxyRefSchema,
});
exports.AppleProxyCreativeQuerySchema = (0, core_1.StrictObject)({
    includeDeletedCreativeSetAssets: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
});
